// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__30tpq","clinicsSelect":"TableHeading_clinicsSelect__D96dq"};